import { MaskInput } from 'maska';

import '../css/global.css';
import { initAnimations } from './animations';
import { initLeadForm } from './lead-form';
import { gateLeadPages } from './lead-session';
import { initSmoothAnchorScroll } from './smooth-anchor-scroll';
import { initSurvey } from './survey';

gateLeadPages();
initAnimations();
initSmoothAnchorScroll({});
initLeadForm();
initSurvey();

// Phone Mask for inputs
document.querySelectorAll('.phone-mask').forEach((input) => {
	new MaskInput(input as HTMLInputElement, {
		mask: ['(##) ####-####', '(##) #####-####'],
	});
});
